import utils from "@/components/declarations/validators/utils";

export default {
  methods: {
    isValid() {
      const errors = {
        atLeastOne: false,
        notAllFields: false
      };

      this.setErrors(errors);
      let text = "";

      if (!this.voivodeship || !this.county || !this.community
        || !this.city || (!this.street && !this.customStreetName)
        || (!this.number && !this.customNumber) || !this.postalCode) {
        text += "Prosimy o wprowadzenie wartości wszystkich pól adresowych <br/>";
        errors.notAllFields = true;
        errors.atLeastOne = true;
      }

      if (errors.atLeastOne) {
        utils.showMessage(this, text);
      }

      return errors;
    }
  }
}
